<template>
  <div class="banner swiper-banner" :class="[{'on':componentContent.categoryShow}]">
    <!-- <el-carousel>
      <el-carousel-item v-for="(item,index) in bannerList" :key="index" :style="{backgroundImage: 'url('+ item.bannerUrl +')',backgroundSize:'cover'}">
        <a class="a-link" @click="jumpLink(item.linkObj)"><img class="img" :src="item.bannerUrl" v-show="item.bannerUrl"></a>
      </el-carousel-item>
    </el-carousel> -->
    <swiper class="weekStore-swiper" :options="swiperOption">
        <swiper-slide class="store-box" v-for="(item,index) in bannerList" :key="index">
            <!-- <a class="a-link" @click="jumpLink(item.linkObj)" v-show="item.bannerUrl" :style="`background-image:url(${item.bannerUrl});background-size:cover;background-position:center`">
            </a> -->
            <a class="a-link" @click="jumpLink(item.linkObj)" v-show="item.bannerUrl" :style="`background-image:url(${bannerImg});background-size:cover;background-position:center`">
              <!-- <img class="img" :src="item.bannerUrl" v-show="item.bannerUrl"> -->
          </a>
        </swiper-slide>
        
    </swiper>
    <div class="swiper-pagination"></div>
  </div>
</template>

<script>
  import {funMixin} from '../../config/mixin'
  import { swiper, swiperSlide} from 'vue-awesome-swiper';
  import 'swiper/dist/css/swiper.css'
  export default {
    name: 'cereBanner',
    mixins: [funMixin],
    components: {
      swiper,
      swiperSlide
    },
    props: {
      // componentContent: {
      //   type: Object
      // },
      curImageUrl:{
          default:{
              url:'',
              backgroundColor:''
          }
      }
    },
    data(){
        return {
          bannerImg:'../../../../../static/image/b2c/banner_1.png',
          componentContent:{
            categoryShow:true,
          bannerData:[
            {
              bannerUrl:"../../../../assets/images/b2c/banner_1.png"
            }
          ]
        },
            swiperOption: {
                // slidesPerView: 'auto',
                // spaceBetween: 30,
                // autoplay: true, // 可选选项，自动滑动
                speed:1000,
                autoplay : {
                    delay:5000,
                    stopOnLastSlide: false,
      　　　　　　　　/* 触摸滑动后是否继续轮播 */
      　　　　　　　　disableOnInteraction: false
                },
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable :true,
                },
                on:{
                    transitionStart: ((app)=>{
                        return function(){
                            // console.log(app)
                            app.curImageUrl.url = app.bannerList[this.realIndex].bannerUrl;
                            // app.curImageUrl.backgroundColor = "#" + app.bannerList[this.realIndex].bannerUrl.split("%23")[1].split(".")[0];
                            // console.log(this.realIndex)
                        }
                    })(this),
                }
                // navigation: {
                //     nextEl: '.swiper-button-next',
                //     prevEl: '.swiper-button-prev'
                // }
            }
        }
    },
    computed: {
      bannerList: function () {
        return this.componentContent.bannerData.filter(function (item) {
          return item.bannerUrl
        })
      }
    },
  }
</script>
<style lang="scss">
    .swiper-banner{
        .swiper-pagination{
            position: absolute;
            bottom: 15px;
            width: 100%;
            text-align: center;
            .swiper-pagination-bullet{
                width: 11px;
                height: 11px;
                margin-right: 13px;
            }
            .swiper-pagination-bullet:last-child{
                margin-right: 0;
            }
            .swiper-pagination-bullet-active{
                background-color: #fff;
            }
        }
    }
</style>
<style lang="scss" scoped>
  .banner{
    position: absolute;
    left: 0;
    top: 10px;
    width: 1034px;
    height: 610px;
    left: 46.3%;
    margin-left: -487px;
    flex: 1;
    .store-box{
        border-radius: 8px;
        overflow: hidden;
        .a-link{
            display: block;
            height: 610px;
            width: 100%;
        }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/canvasShow/cereshop/pc_b2c/bannerSwiper.vue